import { Routes } from '@angular/router';

const prototypeHomeRoute = (portalSection?: 'agent' | 'applications') => ({
  data: {
    portalPrototype: true,
    portalSection,
    title:
      portalSection === 'agent'
        ? 'NAICOM Agent Application'
        : portalSection === 'applications'
          ? 'Other Applications'
          : undefined,
  },
  loadComponent: () => import('./cp-home/cp-home.component').then((c) => c.CpHomeComponent),
});

export const publicPortalPrototypeRoutes: Routes = [
  {
    path: 'portal-prototype',
    loadComponent: () =>
      import('../../../shared/src/lib/components/layouts/horizontal-layout/horizontal-layout.component').then(
        (c) => c.HorizontalLayoutComponent,
      ),
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        ...prototypeHomeRoute(),
      },
      {
        path: 'agent-application',
        ...prototypeHomeRoute('agent'),
      },
      {
        path: 'other-applications',
        ...prototypeHomeRoute('applications'),
      },
    ],
  },
];
